import React, { createContext, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';

import { useAuth } from '../../authentication';
import { useGetDatabaseDescriptionQuery } from '../hooks';
import { useOrganizations } from '../../organization/providers';

const DatabaseDescriptionContext = createContext();

const DatabaseDescriptionProvider = ({ children = null }) => {
  const { accessToken } = useAuth();
  const { currentOrganization } = useOrganizations();

  const dbDescriptionQuery = useGetDatabaseDescriptionQuery(
    accessToken,
    currentOrganization?.id,
    false
  );

  const fullDbDescriptionQuery = useGetDatabaseDescriptionQuery(
    accessToken,
    currentOrganization?.id,
    true
  );

  const value = useMemo(
    () => ({
      databaseDescription: dbDescriptionQuery.data?.filter(
        (schema) => schema.name !== 'multi' && schema.name !== 'metrics'
      ),
      fullDatabaseDescription: fullDbDescriptionQuery.data?.filter(
        (schema) => schema.name !== 'multi' && schema.name !== 'metrics'
      )
    }),
    [dbDescriptionQuery.data, fullDbDescriptionQuery.data]
  );

  return (
    <DatabaseDescriptionContext.Provider value={value}>
      {children}
    </DatabaseDescriptionContext.Provider>
  );
};

DatabaseDescriptionProvider.propTypes = {
  children: PropTypes.node
};

const useDatabaseDescription = () => useContext(DatabaseDescriptionContext);

export { DatabaseDescriptionProvider, DatabaseDescriptionContext, useDatabaseDescription };
